//
import React from 'react';
import { StyleSheet, TextStyle, StyleProp, Text } from 'react-native';
import { TXT_GG } from '../../constants';
import colors from '../../colors';

type Props = {
  style?: StyleProp<TextStyle>;
};

const Title: React.FC<Props> = (props) => {
  const { children, style } = props;
  return <Text style={[styles.titulo, style]}>{children}</Text>;
};

const styles = StyleSheet.create({
  titulo: {
    fontSize: TXT_GG,
    fontWeight: '700',
    color: colors.primary
  }
});

export default Title;
